// T3-B PR 4 (2026-05-12) / PR 4-bis (2026-05-12):
//   tier preset CRUD API クライアント (omikuji-api PR #117 / #118)。
//   CMS sponsored 入稿フォームの tier 選択 dropdown + tier プリセット管理画面で使用。
//   auth: ADMIN only。

import ApiService from './ApiService';

export default class FortuneTierPresetApi extends ApiService {
    // GET /system/fortune-tier-presets[?include_inactive=1]
    list(payload?: { include_inactive?: 0 | 1 }) {
        return this.get('fortune-tier-presets', payload);
    }

    // GET /system/fortune-tier-presets/:id
    getById(id: string | number) {
        return this.get(`fortune-tier-presets/${id}`);
    }

    // POST /system/fortune-tier-presets
    create(payload: any) {
        return this.post('fortune-tier-presets', payload);
    }

    // PUT /system/fortune-tier-presets/:id
    update(payload: { id: string | number, data: any }) {
        const { id, data } = payload;
        return this.put(`fortune-tier-presets/${id}`, data);
    }

    // DELETE /system/fortune-tier-presets/:id
    remove(id: string | number) {
        return this.delete(`fortune-tier-presets/${id}`);
    }
}
